export default __webpack_public_path__ + "static/t-animoca-adaae7c7575eecd5adf3ef45a96f71db.png";